import { Icon } from "@material-ui/core";
import Toolbar from "Components/Common/Toolbar/Toolbar";
import RouterLink from "Components/RouterLink/RouterLink";
import { RouterLinkType } from "Enums/RouterLinkType";
import * as React from "react";
import i18n from "Translations/i18n";
import styles from "./AuditTemplateBlockOverviewHeader.scss";

const AuditTemplateBlockOverviewHeader: React.FunctionComponent<{}> = () => (
    <div className={styles.auditTemplateOverviewHeader}>
        <Toolbar>
            <RouterLink to="/audittemplates/new" type={RouterLinkType.default}>
                <button>
                    <Icon>add</Icon>
                    {i18n.t("audits.createNewAudit")}
                </button>
            </RouterLink>
        </Toolbar>
        <h1>{i18n.t("audits.blockOverviewTitle")}</h1>
    </div>
);

export default AuditTemplateBlockOverviewHeader;


// WEBPACK FOOTER //
// ./src/Components/Pages/AuditTemplateBlockOverview/AuditTemplateBlockOverviewHeader/AuditTemplateBlockOverviewHeader.tsx